import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={188}
        height={215}
        viewBox="0 0 188 215"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10.8427 214.5C-3.21748 169.922 -11.9598 84.1934 65.5522 97.901C162.442 115.036 139.278 157.807 128.197 170.619C120.154 179.918 101.881 182.456 92.6982 140.947C83.503 99.3816 81.0045 -23.2946 187.5 5.95954"
            stroke="#FCA61F"
            strokeOpacity={0.4}
            strokeWidth={3}
        />
    </svg>
);

const Line = React.memo(SVGComponent);

export default Line;
